module.exports = __webpack_public_path__ + "media/images/athletes/1811-be4d33a8be9756a5fc685d69c7c2f71c.png";